import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    promptText: {
        padding: '1.5rem 0',
        fontSize: '1.25rem'
    },
    buttonContainer: { paddingTop: '2.5rem' },
    cancelButton: {
        cursor: 'pointer' as const,
        fontSize: '1.2rem',
        lineHeight: '1.2rem',
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        padding: '.3rem',
        marginTop: '1rem',
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryHover ||
                '#bec4cf'
        }
    }
});